// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { arrayFlatten } from '@polkadot/util';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
var DEFAULT_FLAGS = {
  withController: true,
  withExposure: true,
  withPrefs: true
};

function combineAccounts(nextElected, validators) {
  return arrayFlatten([nextElected, validators.filter(function (v) {
    return !nextElected.find(function (n) {
      return n.eq(v);
    });
  })]);
}

export function electedInfo(instanceId, api) {
  return memo(instanceId, function () {
    var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FLAGS;
    return api.derive.staking.validators().pipe(switchMap(function (_ref) {
      var nextElected = _ref.nextElected,
          validators = _ref.validators;
      return api.derive.staking.queryMulti(combineAccounts(nextElected, validators), flags).pipe(map(function (info) {
        return {
          info: info,
          nextElected: nextElected,
          validators: validators
        };
      }));
    }));
  });
}